import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import { Button, Paper, Box, TextField, Autocomplete, Stack } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { ModuleRegistry, AllCommunityModule, themeQuartz } from 'ag-grid-community';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, LabelList } from 'recharts';
import { useGetCRMDashboardMutation, useGetSMSContentMutation } from '../../services/consumer';
import LoadingPage from '../loadingPage';
import AlertSnackbar from '../alertSnackbar';
import "react-day-picker/style.css";
import moment from 'moment';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import DateRange from '../tools/daterange';
import AutocompleteWithAll from '../tools/autocompleteWithAll';
import SMSImport from './smsimport';
import TreeSelect from '../tools/treeSelect';
const API_URI = process.env.REACT_APP_API_URI;

export default function CRMDashboard() {
  const [getData, dataResult] = useGetCRMDashboardMutation();
  const [getSMSContent, smsContentResult] = useGetSMSContentMutation();
  const [dataLoaded, setDataLoaded] = useState([]);
  const [columns, setCoumns] = useState([]);
  const [gridHeight, setGridHeight] = useState(300);
  const [snackContent, setSnackContent] = useState("");
  const [range, setRange] = useState({from: moment().startOf('month'), to: moment()});
  const [viewDetail, setViewDetail] = useState(0);
  const [openImport, setOpenImport] = useState(false);
  const [smsContent, setSMSContent] = useState([]);
  const [selectedSMS, setSelectedSMS] = useState({});
  const [selectedValue, setSelectedValue] = useState('');
  const [dataCombo, setDataCombo] = useState([
    {
      id: "DANH MỤC A",
      label: "DANH MỤC A",
      children: [
        { id: "CON SỐ 1", label: "CON SỐ 1" },
        { id: "CON SỐ 2", label: "CON SỐ 2" },
        {
          id: "ĐỘNG CƠ MÁY XĂNG",
          label: "ĐỘNG CƠ MÁY XĂNG",
          children: [
            { id: "THAY BUỒNG ĐỐT XĂNG", label: "THAY BUỒNG ĐỐT XĂNG" },
            { id: "VỆ SINH CỔ HÚT", label: "VỆ SINH CỔ HÚT" }
          ]
        }
      ]
    },
    {
      id: "THAY DUNG DỊCH",
      label: "THAY DUNG DỊCH",
      children: [
        { id: "THAY DẦU THẮNG", label: "THAY DẦU THẮNG" },
        { id: "THAY NHỚT CẦU", label: "THAY NHỚT CẦU" },
      ]
    }
  ]);

  const gridRef = useRef();
  const containerRef = useRef(null);
  const [pinnedBottomRowData, setPinnedBottomRowData] = useState([
      { make: 'Total', model: '', TOTAL: 0 }
  ]);

  ModuleRegistry.registerModules([ AllCommunityModule ]);

  useEffect(() => {
    handleGridHeight();
    getSMSContent();
  }, []);

  const handleGridHeight = () =>{
    const divHeader = document.getElementById('divHeader');
    setGridHeight(window.innerHeight - (divHeader?divHeader.clientHeight:0) - 72);
  }

  useEffect(() => {
    if(dataResult.data)
    {
      const dt = JSON.parse(dataResult.data);
      setDataLoaded(dt);
      if(dt.length > 0)
        getCoumns(dt[0]);
      updatePinnedBottomRow(null, dt);
    }
  }, [dataResult]);

  useEffect(() => {
    if(smsContentResult.data)
    {
      const dt = JSON.parse(smsContentResult.data);
      let st = [];
      dt.map((m, index)=>{
        st.push({value: m.SMSContent, label: m.SMSContent + (index?` (${moment(m.DateTimeSent).format('DD/MM/YYYY')})`:''), ...m})
      })
      setSMSContent(st);

      
      const groups = {};
      dt.forEach(item => {
        const date = new Date(item.DateTimeSent);
        const year = date.getFullYear().toString();
        const month = `Tháng ${(date.getMonth() + 1).toString().padStart(2, '0')}`;

        if (!groups[year]) groups[year] = {};
        if (!groups[year][month]) groups[year][month] = [];
        groups[year][month].push({
          id: item.SMSContent,
          label: item.SMSContent
        });
      });

      const formattedTreeData = Object.keys(groups)
      .sort((a, b) => b - a) // Sắp xếp Năm gần nhất lên đầu
      .map(year => {
        const monthsArray = Object.keys(groups[year])
          .sort((a, b) => b.localeCompare(a)) // Sắp xếp Tháng gần nhất lên đầu
          .map(month => {
            return {
              id: `${year}-${month}`,
              label: month,
              children: groups[year][month] // Danh sách các SMSContent bên trong tháng đó
            };
          });

        return {
          id: year,
          label: `Năm ${year}`,
          children: monthsArray
        };
      });
      
      setDataCombo(formattedTreeData);
    }
  }, [smsContentResult]);

  useEffect(() => {
    if(selectedValue)
    {
      const record = smsContent.find(f=>f.value == selectedValue);
      if(record && record.DateTimeSent && record.EndDate){
        setSelectedSMS(record);
        setRange({from: moment(record.DateTimeSent), to: moment(record.EndDate)});
      }
    }
  }, [selectedValue]);

  const getDataView=()=>{
    if(!range) return;
    setViewDetail(0);
    getData({"fromDate": moment(range.from).format('YYYY-MM-DD')
      , "toDate": moment(range.to).format('YYYY-MM-DD'), "type": 0
      , smsContent: selectedSMS?selectedSMS.value:''});
    handleGridHeight();
    gridRef.current.setFilterModel(null);
  }

  const getDataChart=()=>{
    if(!range) return;
    setViewDetail(1);
    getData({"fromDate": moment(range.from).format('YYYY-MM-DD')
      , "toDate": moment(range.to).format('YYYY-MM-DD'), "type": 1
      , smsContent: selectedSMS?selectedSMS.value:''});
    handleGridHeight();
    gridRef.current.setFilterModel(null);
  }

  const onChangeSMS=(record)=>{
    setSelectedSMS(record);
    if(record && record.DateTimeSent && record.EndDate)
      setRange({from: moment(record.DateTimeSent), to: moment(record.EndDate)});
  }

  const getCoumns=(item)=>{
    const cols = Object.keys(item).map((key) => {
      return {
        field: key,
        filter: true,
        cellStyle: () => ((key=="TotalGross" || key=="CRMDiscount" || key=="TotalNet")
        ?{
          display: "flex",
          alignItems: "right",
          justifyContent: "right",
          fontWeight: key=="TotalNet" ? "bold" : ""
        }:null),
        valueFormatter: params => params.data[key] && (
          (key=="PrevBill")?moment(params.data[key]).format("YYYY-MM-DD")
          :(key=="TotalGross" || key=="CRMDiscount" || key=="TotalNet")?new Intl.NumberFormat('en-US').format(params.data[key]):params.data[key]
        )
      }
    });
    setCoumns(cols);
  }

  const onGridReady = useCallback((params) => {
    gridRef.current = params.api;
    updatePinnedBottomRow(params.api); // Initial calculation
  }, []);

  const updatePinnedBottomRow = (api, data) => {
    let TotalGross = 0, CRMDiscount = 0, TotalNet = 0;
    if(data)
      data.map(m=>{
        TotalGross += m.TotalGross;
        CRMDiscount += m.CRMDiscount;
        TotalNet += m.TotalNet;
      })
    else
      api.forEachNodeAfterFilter((node) => {
          TotalGross += node.data.TotalGross;
      });
    setPinnedBottomRowData([{ make: 'Total', model: '', TotalGross: TotalGross, CRMDiscount: CRMDiscount, TotalNet: TotalNet }]);
  };

  const onFilterChanged = useCallback(() => {
    if (gridRef.current) {
        updatePinnedBottomRow(gridRef.current);
    }
  }, []);

  const exportExcel = () => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const ws = XLSX.utils.json_to_sheet(dataLoaded);
    const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], {type: fileType});
    saveAs(data, "ConsumerSMS.xlsx");
  }

  const getRowClass = useCallback(params => {
    if (params.node.rowIndex % 2 === 1) {
        return "grid-odd-rows";
    }
    if (params.node.rowPinned === 'bottom') {
      return "text-bold";
    }
  }, []);

  const myTheme = themeQuartz.withParams({
    // borderColor: "#9696C8",
    wrapperBorder: false,
    headerRowBorder: false,
    // rowBorder: { style: "dotted", width: 1 },
    columnBorder: { style: "dashed", color: '#9696C8' },
    headerColumnBorder: { style: 'solid', width: 1, color: '#ccc' },
  });

  const theme = useMemo(() => {
    return myTheme;
  }, []);

  const renderCustomDot = (props) => {
    const { cx, cy, payload } = props;

    // Change color based on your data property
    const ddd = moment(payload.InvDate).format('ddd');
    const dotColor = (ddd == 'Fri' || ddd == 'Sat' || ddd == 'Sun') ? '#FF0000' : '#8884d8'; 

    return (
      <circle 
        cx={cx} 
        cy={cy} 
        r={5} 
        fill={dotColor} 
        stroke="none" 
      />
    );
  };

  return (
    <div style={{padding: '0 10px'}}>
      { (dataResult.isLoading) && <LoadingPage /> }
      <div style={{marginTop: '10px'}}>
        <Box id='divHeader' sx={{ width: '100%' }}>
          <Stack
            direction="row"
            spacing={1.5}
            alignItems="center"
            sx={{
              overflowX: 'auto', pt: 1, mb: 0.5,
              pb: 0.5, // Space for the scrollbar so it doesn't touch the buttons
              '&::-webkit-scrollbar': {
                height: '6px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#ccc',
                borderRadius: '10px',
              },
              // Ensure items don't shrink and stay on one line
              flexWrap: 'nowrap',
            }}
          >
            {/* <Autocomplete disablePortal size="small"
              options={smsContent}
              sx={{ flexShrink: 0, width: 500, marginRight: '10px', marginBottom: '10px' }}
              onChange={(e, item)=>onChangeSMS(item)}
              renderInput={(params) => <TextField {...params} label="SMS" />}
              loading={smsContentResult.isLoading}
              getOptionLabel={(option) => option.label}
              renderOption={(props, option) => (
                <li {...props} style={{ color: option.hex }}>
                  {option.label}
                </li>
              )}
              disableClearable
            /> */}
            <TreeSelect 
              data={dataCombo} 
              value={selectedValue} 
              onChange={(val) => setSelectedValue(val)}
              placeholder="Tìm kiếm nhanh sms..."
              width={500}
            />

            {selectedSMS.value=="Khách Hàng Có Sinh Nhật Trong Tháng"?
            <Box sx={{'& .MuiStack-root': {padding: '0px', overflow: 'hidden'}
                                , '& .MuiPickersSectionList-root': {padding: '9px 0px'}
                                , '& .MuiPickersTextField-root': {minWidth: 0}
                                , '& .MuiPickersInputBase-root': {fontSize: '15.5px', width: '135px', minWidth: '135px'}
                                , '& .MuiButtonBase-root': {height: '30px'} }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DemoContainer components={['DatePicker', 'DatePicker', 'DatePicker']}>
                  <DatePicker label={''} views={['month', 'year']} format="MMM YYYY" 
                    value={range.from?range.from:moment()} 
                    onChange={(date)=>setRange({from: moment(date).startOf('month'), to: moment(date).endOf('month')})}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>:
            <DateRange range={range} setRange={setRange} />}
            {/* <RadioGroup
              sx={{ marginLeft: '10px' }}
              aria-labelledby="gender-radio-group-label"
              id="gender"
              name="gender"
              value={viewDetail}
              onChange={(e)=>setViewDetail(e.target.value)}
              row // Optional: Arranges radio buttons horizontally
            >
              <FormControlLabel value="0" control={<Radio />} label="Total" />
              <FormControlLabel value="1" control={<Radio />} label="Detail" />
            </RadioGroup> */}
            <Button variant="contained" onClick={getDataView}
              sx={{ marginRight: '10px', marginBottom: '10px', marginLeft: '10px' }}>View</Button>
            <Button variant="contained" onClick={getDataChart}
              sx={{ marginRight: '10px', marginBottom: '10px' }}>View Chart</Button>
            <Button variant="contained" onClick={()=>setOpenImport(true)}
              sx={{ marginRight: '10px', marginBottom: '10px' }}>Import SMS</Button>
            <Button variant="contained" onClick={exportExcel}
              sx={{ marginRight: '10px', marginBottom: '10px' }}>Export</Button>
          </Stack>
        </Box>
        {viewDetail==0?
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
          <AgGridReact
            rowData={dataLoaded}
            columnDefs={columns}
            pagination={true}
            paginationPageSize={500}
            paginationPageSizeSelector={[200, 500, 1000]}
            pinnedBottomRowData={pinnedBottomRowData}
            getRowClass={getRowClass}
            theme={theme}
            onGridReady={onGridReady}
            onFilterChanged={onFilterChanged}
          />
        </Paper>
        :
        <Paper sx={{ height: gridHeight, width: '100%', float: 'left' }}>
          <ResponsiveContainer>
            <LineChart
              data={dataLoaded?dataLoaded:[]}
              margin={{ top: 5, right: 30, left: 30, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="InvDate" hide={true} />
              <YAxis tickFormatter={(value) => `${value.toLocaleString()} M`} />
              <Tooltip 
                labelFormatter={(label) => `Date: ${moment(label).format('DD/MM/YYYY')}`}
                formatter={(value, name) => [`${value} M`, name]}
              />
              <Legend />
              { /*<Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />*/ }
              <Line type="monotone" dataKey="TotalNet" stroke="#0092388b" strokeWidth={5} dot={renderCustomDot}>
                <LabelList dataKey="InvDate" position="bottom" fill='blue' style={{zIndex: 1000}}
                  formatter={(value) => `${moment(value).format('DD')}`} />
              </Line>
            </LineChart>
          </ResponsiveContainer>
        </Paper>
        }
        
        {/* <CustomTable /> */}
      </div>

      <SMSImport open={openImport} setOpen={setOpenImport} selectedSMS={selectedSMS} />

      <AlertSnackbar message={snackContent} setSnackContent={setSnackContent}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} />
    </div>
  )
}